import axios from '../axios';
import config from '../../config';
const { leaderURL } = config;
export default {
    // 获取球员列表
    getPlayerList(params) {
        return axios(leaderURL + `/players`, {
            method: 'get',
            params,
        });
    },
    // 获取球员列表
    getPlayerStatistics(params) {
        return axios(leaderURL + `/player/statistics`, {
            method: 'get',
            params,
        });
    },
    getWPlayerStatistics(params) {
        return axios(leaderURL + `/woman/player/statistics`, {
            method: 'get',
            params,
        });
    },
    getTSStatistics(params) {
        return axios(leaderURL + `/woman/scout/statistics`, {
            method: 'get',
            params,
        });
    },
    getWCampStatistics(params) {
        return axios(leaderURL + `/woman/triaining-camp/statistics`, {
            method: 'get',
            params,
        });
    },
    // 获取球员详情
    getPlayerDetails(id, tenant_id) {
        return axios(leaderURL + `/player/${id}?tenant_id=${tenant_id}`, {
            method: 'get',
        });
    },
    // 球员评估列表
    getPlayerEvel(id, tenant_id) {
        return axios(leaderURL + `/player/${id}/evaluations?tenant_id=${tenant_id}`, {
            method: 'get',
        });
    },
    // 球员视频分析
    getPlayerVideo(id, tenant_id) {
        return axios(leaderURL + `/player/${id}/video-clip/statistics?tenant_id=${tenant_id}`, {
            method: 'get',
        });
    },
    // 球员体测报告列表
    getPlayerTestReport(id, tenant_id) {
        return axios(leaderURL + `/player/${id}/physicals?tenant_id=${tenant_id}`, {
            method: 'get',
        });
    },
    // 球员伤病数据
    getInjuryData(id, tenant_id) {
        return axios(leaderURL + `/player/${id}/injuries?tenant_id=${tenant_id}`, {
            method: 'get',
        });
    },
  // 获取女足球员列表
  getWomanPlayerList(params) {
    return axios(leaderURL + `/woman/players`, {
      method: 'get',
      params,
    });
  },
};
